export const postSegmentEvent = (eventName, eventProps) => {
  if (typeof window == 'undefined') return;
  const analyticsPayload = {
    eventType: 'track',
    eventName: eventName,
    eventProps: eventProps,
  };
  window.parent.postMessage(analyticsPayload, '*');
};
